import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { TextInput } from '@els/els-react--text-input';

export default function GroupOfMoreInput(props) {
  const { id, option, groupId, optionId, onChangeInput, disableIncludeAndMoreGroup } = props;
  const title = option.get('title');
  const inputValue = option.get('inputValue');
  const isInputEmpty = !inputValue;
  const clearInputIcon = isInputEmpty
    ? undefined
    : {
        id: `group-of-more-input-clear-${optionId}`,
        sprite: 'Close',
        children: 'Clear input',
      };
  const handleClearInput = isInputEmpty ? undefined : () => onChangeInput(id, groupId, optionId, '');

  return (
    <TextInput
      data-e2e="group-of-more-input"
      className="group-of-more-input"
      disabled={disableIncludeAndMoreGroup}
      iconRight={clearInputIcon}
      iconRightCallback={handleClearInput}
      label={title}
      shouldHideLabel
      onChange={(event) => {
        onChangeInput(id, groupId, optionId, event?.target?.value);
      }}
      value={inputValue}
      placeholder={title}
    />
  );
}

GroupOfMoreInput.propTypes = {
  id: PropTypes.string.isRequired,
  option: PropTypes.instanceOf(Map),
  groupId: PropTypes.string.isRequired,
  optionId: PropTypes.string.isRequired,
  onChangeInput: PropTypes.func.isRequired,
  disableIncludeAndMoreGroup: PropTypes.bool.isRequired,
};
